import { useEffect, useRef } from "react";
import { trackSiteEvent } from "../utils/siteAnalytics";
import { previewQueryPath } from "../paths";

export default function SiteAnalyticsTracker({ path, title }) {
  const lastPathRef = useRef("");

  useEffect(() => {
    if (previewQueryPath()) return;
    const nextPath = path || (typeof window !== "undefined" ? window.location.pathname : "");
    if (!nextPath || lastPathRef.current === nextPath) return;
    lastPathRef.current = nextPath;
    trackSiteEvent("pageview", { path: nextPath, title });
  }, [path, title]);

  return null;
}
